import { MapPosition } from "../common";
import { AccountIntegration } from "../accountIntegration/types";
import { AccountBranch } from "../accountBranch/types";
import { GeoZone } from "../geoZone";

/**
 * Delivery types to distinguish between shipping and pickup options
 */
export enum DeliveryType {
	SHIPPING = "SHIPPING",
	PICKUP = "PICKUP",
}

/**
 * Entidad AccountDeliveryOption
 * Representa una opción de envío de una cuenta.
 */

export interface AccountDeliveryOption {
	id: string;
	accountId: string;
	accountBranchId: string;
	name: string;
	accountIntegrationId?: string;
	isScheduled: boolean;
	priceLogic: AccountDeliveryOptionPriceLogic;
	status: AccountDeliveryOptionStatus;
	deliveryType: DeliveryType;
	demo:boolean;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date | null;
	data?: Record<string, unknown>

	deliveryZones: AccountDeliveryOptionZone[];
	integration?: AccountIntegration | null;
	price?: number | null;
	accountBranch?: AccountBranch | null;
}

export enum AccountDeliveryOptionPriceLogic {
	FIXED = "FIXED",
	CALCULATED = "CALCULATED",
}

export enum AccountDeliveryOptionStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

export interface AccountDeliveryOptionCalculatedCost {
	basePrice: number;
	distanceKm: number;
	finalPrice: number;
	priceLogic: AccountDeliveryOptionPriceLogic;
	currency: string;
}


export interface AccountDeliveryOptionZone {
	id: string;
	accountId: string;
	accountDeliveryOptionId: string;
	geoZoneId: string;
	status: AccountDeliveryOptionZoneStatus;
	demo: boolean;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date | null;

	// Relations
	geoZone?: GeoZone;
}

export enum AccountDeliveryOptionZoneStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

// DTO Types for API operations
export interface DeliveryZoneInput {
	geoZoneId?: string;
	geoZone?: GeoZoneInput;
}

export interface GeoZoneInput {
	name: string;
	area: MapPosition[];
	description?: string;
}

export interface CreateAccountDeliveryOptionDTO {
	accountId: string;
	accountBranchId: string;
	name: string;
	accountIntegrationId?: string | null;
	isScheduled?: boolean;
	priceLogic?: AccountDeliveryOptionPriceLogic;
	price?: number;
	status?: AccountDeliveryOptionStatus;
	deliveryType: DeliveryType;
	deliveryZones?: DeliveryZoneInput[];
	data?: Record<string, unknown>;
}

export interface UpdateAccountDeliveryOptionDTO {
	accountBranchId: string;
	name?: string;
	accountIntegrationId?: string | null;
	isScheduled?: boolean;
	priceLogic?: AccountDeliveryOptionPriceLogic;
	status?: AccountDeliveryOptionStatus;
	deliveryType?: DeliveryType;
	deliveryZones?: DeliveryZoneInput[];
	data?: Record<string, unknown>;
}